import React from 'react';
import { HeadFC, graphql } from 'gatsby';
import { getSrc } from 'gatsby-plugin-image';

interface DataType {
  file: {
    childJson: {
      meta: {
        title: string;
        description: string;
        image: {
          childImageSharp: { gatsbyImageData: Record<string, string> };
        };
        twitter: string;
      };
    };
  };
}

interface PageContext {
  locale: string;
}

const Head: HeadFC<DataType, PageContext> = props => {
  const {
    data: {
      file: {
        childJson: {
          meta: {
            title,
            description,
            image: {
              childImageSharp: { gatsbyImageData },
            },
            twitter,
          },
        },
      },
    },
    location: { pathname },
    pageContext: { locale },
  } = props;

  const image = getSrc(gatsbyImageData);

  return (
    <>
      <html key="html" lang={locale} />

      <title key="title">{title}</title>
      <meta key="description" name="description" content={description} />

      <meta key="og:title" property="og:title" content={title} />
      <meta
        key="og:description"
        property="og:description"
        content={description}
      />
      <meta
        key="og:image"
        property="og:image"
        content={`https://www.bitcoin.com${image}`}
      />
      <meta
        key="og:image_secure"
        property="og:image:secure_url"
        content={`https://www.bitcoin.com${image}`}
      />
      <meta key="og:image_width" property="og:image:width" content="1200" />
      <meta key="og:image_height" property="og:image:height" content="630" />

      <meta
        key="twitter:card"
        name="twitter:card"
        content="summary_large_image"
      />
      <meta key="twitter:site" name="twitter:site" content={`@${twitter}`} />
      <meta key="twitter:title" name="twitter:title" content={title} />
      <meta
        key="twitter:description"
        name="twitter:description"
        content={description}
      />
      <meta
        key="twitter:image"
        name="twitter:image"
        content={`https://www.bitcoin.com${image}`}
      />

      <link
        key="canonical"
        rel="canonical"
        href={`https://www.bitcoin.com${pathname}`}
      />
    </>
  );
};

export const query = graphql`
  fragment Meta on Json {
    meta {
      title
      description
      image {
        childImageSharp {
          gatsbyImageData
        }
      }
      twitter
    }
  }
`;

export default Head;
